import { render } from "./Friends.vue?vue&type=template&id=3c6c646a"
import script from "./Friends.vue?vue&type=script&lang=js"
export * from "./Friends.vue?vue&type=script&lang=js"

import "./Friends.vue?vue&type=style&index=0&id=3c6c646a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Friends.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c6c646a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c6c646a', __exports__)) {
    api.reload('3c6c646a', __exports__)
  }
  
  module.hot.accept("./Friends.vue?vue&type=template&id=3c6c646a", () => {
    api.rerender('3c6c646a', render)
  })

}


export default __exports__